// La única forma en que la app escribe una fecha o una hora: día/mes/año y 24 horas, sin segundos, en la hora de la
// computadora de quien mira. No se usa `toLocaleString`: deja el formato al idioma del navegador, y en español de
// Argentina la hora sale en 12 horas y sin "a. m./p. m." (las 15:02 se leen "03:02").
const two = (n) => String(n).padStart(2, '0');
const asDate = (value) => (value instanceof Date ? value : new Date(value));
const valid = (date) => !Number.isNaN(date.getTime());

// "8/10/2026"
export const formatDate = (value) => {
    const date = asDate(value);
    return valid(date) ? `${date.getDate()}/${date.getMonth() + 1}/${date.getFullYear()}` : '';
};

// "15:02"
export const formatTime = (value) => {
    const date = asDate(value);
    return valid(date) ? `${two(date.getHours())}:${two(date.getMinutes())}` : '';
};

// "8/10/2026 15:02"
export const formatDateTime = (value) => (valid(asDate(value)) ? `${formatDate(value)} ${formatTime(value)}` : '');

// --- Días (los campos de fecha de un filtro trabajan con "AAAA-MM-DD", en la hora de la computadora) ---

const localDay = (isoDay) => { const [year, month, day] = isoDay.split('-').map(Number); return new Date(year, month - 1, day); };

// "2026-10-08": el día de hoy, o el de `offset` días antes o después.
export const isoDay = (offset = 0, from = new Date()) => {
    const date = new Date(from.getFullYear(), from.getMonth(), from.getDate() + offset);
    return `${date.getFullYear()}-${two(date.getMonth() + 1)}-${two(date.getDate())}`;
};

// Un rango de días como instantes: desde el principio del primero hasta el principio del siguiente al último.
// Así el servidor corta los días donde los corta quien mira, y no en UTC.
export const dayRangeAsInstants = (fromDay, toDay) => {
    const range = {};
    if (fromDay) range.since = localDay(fromDay).toISOString();
    if (toDay) { const end = localDay(toDay); end.setDate(end.getDate() + 1); range.until = end.toISOString(); }
    return range;
};

// "8/10/2026" a partir de "2026-10-08".
export const formatIsoDay = (day) => formatDate(localDay(day));

// La zona horaria del navegador, como la necesita el servidor para escribir un CSV con las horas de la pantalla.
export const browserZone = () => {
    let tz = '';
    try { tz = Intl.DateTimeFormat().resolvedOptions().timeZone || ''; } catch (e) { /* sin Intl: alcanza el desplazamiento */ }
    return { tz, tz_offset: -new Date().getTimezoneOffset() };
};

// --- Encabezado de un día en una lista agrupada por fecha ---

const WEEKDAYS = ['domingo', 'lunes', 'martes', 'miércoles', 'jueves', 'viernes', 'sábado'];

// La clave del día (en la hora local) al que pertenece una fecha: lo que tienen en común las filas de un mismo grupo.
export const dayKey = (value) => isoDay(0, asDate(value));

// { relative: 'Hoy' | 'Ayer' | '', text: 'jueves 8/10/2026' } para el día de esa fecha.
export const dayHeading = (value, now = new Date()) => {
    const date = asDate(value);
    const key = dayKey(date);
    return { relative: key === isoDay(0, now) ? 'Hoy' : key === isoDay(-1, now) ? 'Ayer' : '', text: `${WEEKDAYS[date.getDay()]} ${formatDate(date)}` };
};
